export default __webpack_public_path__ + "static/media/battery_replacement.d5cd63d3.svg";